import { FaTasks, FaPlus, FaCheckCircle, FaCircle, FaFilter } from "react-icons/fa";
import { useState } from "react";

export default function Tasks() {
  const departments = [
    "All",
    "Academic Staff",
    "Researchers",
    "Communications",
    "HR",
    "Belonging",
    "OSG",
    "Chair",
    "Vice Chair",
    "Governance Liaison Officer",
  ];

  const [selectedDepartment, setSelectedDepartment] = useState("All");
  
  const [tasks, setTasks] = useState([
    {
      id: 1,
      title: "Review staff feedback survey results",
      description: "Analyze survey responses and prepare summary report",
      assignee: "Sarah Johnson",
      department: "Academic Staff",
      dueDate: "2025-01-20",
      priority: "high",
      status: "in-progress",
    },
    {
      id: 2,
      title: "Update council website",
      description: "Add new members and update meeting schedule",
      assignee: "Mike Chen",
      department: "Communications",
      dueDate: "2025-01-18",
      priority: "medium",
      status: "todo",
    },
    {
      id: 3,
      title: "Organize team building event",
      description: "Plan and coordinate Q1 team building activities",
      assignee: "Emily Rodriguez",
      department: "Belonging",
      dueDate: "2025-02-01",
      priority: "medium",
      status: "todo",
    },
    {
      id: 4,
      title: "Prepare annual report",
      description: "Compile activities and achievements for 2024",
      assignee: "David Kim",
      department: "Chair",
      dueDate: "2025-01-10",
      priority: "high",
      status: "completed",
    },
    {
      id: 5,
      title: "Review research proposals",
      description: "Evaluate submitted research grant applications",
      assignee: "Dr. Ahmed",
      department: "Researchers",
      dueDate: "2025-01-25",
      priority: "high",
      status: "todo",
    },
    {
      id: 6,
      title: "Update HR policies",
      description: "Revise staff handbook with new guidelines",
      assignee: "Lisa Martinez",
      department: "HR",
      dueDate: "2025-02-05",
      priority: "medium",
      status: "in-progress",
    },
    {
      id: 7,
      title: "Coordinate with OSG",
      description: "Align staff council initiatives with student governance",
      assignee: "John Davis",
      department: "OSG",
      dueDate: "2025-01-22",
      priority: "medium",
      status: "todo",
    },
    {
      id: 8,
      title: "Review governance procedures",
      description: "Update council bylaws and procedures",
      assignee: "Patricia Lee",
      department: "Governance Liaison Officer",
      dueDate: "2025-01-28",
      priority: "high",
      status: "in-progress",
    },
  ]);

  const getPriorityColor = (priority) => {
    switch (priority) {
      case "high":
        return { bg: "#fee", color: "#c53030" };
      case "medium":
        return { bg: "#fef5e7", color: "#d97706" };
      case "low":
        return { bg: "#e6f7ff", color: "#1890ff" };
      default:
        return { bg: "#f0f0f0", color: "#718096" };
    }
  };

  const getStatusIcon = (status) => {
    if (status === "completed") {
      return <FaCheckCircle style={{ color: "#38a169", fontSize: "20px" }} />;
    }
    return <FaCircle style={{ color: "#cbd5e0", fontSize: "20px" }} />;
  };

  const toggleTaskStatus = (taskId) => {
    setTasks(
      tasks.map((task) =>
        task.id === taskId
          ? {
              ...task,
              status: task.status === "completed" ? "todo" : "completed",
            }
          : task
      )
    );
  };

  // Filter tasks by department
  const filteredTasks = selectedDepartment === "All" 
    ? tasks 
    : tasks.filter((t) => t.department === selectedDepartment);

  const activeTasks = filteredTasks.filter((t) => t.status !== "completed");
  const completedTasks = filteredTasks.filter((t) => t.status === "completed");

  const getDepartmentColor = (department) => {
    const colors = {
      "Academic Staff": { bg: "#e6f7ff", color: "#1890ff" },
      "Researchers": { bg: "#f0e6ff", color: "#7c3aed" },
      "Communications": { bg: "#fef5e7", color: "#d97706" },
      "HR": { bg: "#ffe6e6", color: "#dc2626" },
      "Belonging": { bg: "#e6ffe6", color: "#16a34a" },
      "OSG": { bg: "#ffe6f0", color: "#db2777" },
      "Chair": { bg: "#e6f2ff", color: "#0284c7" },
      "Vice Chair": { bg: "#f0f9ff", color: "#0369a1" },
      "Governance Liaison Officer": { bg: "#fef3e6", color: "#ea580c" },
    };
    return colors[department] || { bg: "#f0f0f0", color: "#718096" };
  };

  const TaskCard = ({ task }) => {
    const priorityStyle = getPriorityColor(task.priority);
    const departmentStyle = getDepartmentColor(task.department);

    return (
      <div
        style={{
          background: "white",
          borderRadius: "12px",
          padding: "20px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
          border: "1px solid #e2e8f0",
          marginBottom: "16px",
          opacity: task.status === "completed" ? 0.7 : 1,
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "16px",
            alignItems: "start",
          }}
        >
          <button
            onClick={() => toggleTaskStatus(task.id)}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: "4px",
              marginTop: "2px",
            }}
          >
            {getStatusIcon(task.status)}
          </button>

          <div style={{ flex: 1 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "start",
                marginBottom: "8px",
                gap: "12px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                <h3
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#2d3748",
                    margin: 0,
                    textDecoration:
                      task.status === "completed" ? "line-through" : "none",
                  }}
                >
                  {task.title}
                </h3>
                {selectedDepartment === "All" && (
                  <span
                    style={{
                      padding: "4px 10px",
                      borderRadius: "20px",
                      fontSize: "11px",
                      fontWeight: "500",
                      background: departmentStyle.bg,
                      color: departmentStyle.color,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {task.department}
                  </span>
                )}
              </div>
              <span
                style={{
                  padding: "4px 12px",
                  borderRadius: "20px",
                  fontSize: "12px",
                  fontWeight: "500",
                  background: priorityStyle.bg,
                  color: priorityStyle.color,
                  textTransform: "capitalize",
                  whiteSpace: "nowrap",
                }}
              >
                {task.priority}
              </span>
            </div>

            <p
              style={{
                color: "#4a5568",
                fontSize: "14px",
                marginBottom: "12px",
                lineHeight: "1.5",
              }}
            >
              {task.description}
            </p>

            <div
              style={{
                display: "flex",
                gap: "20px",
                flexWrap: "wrap",
                fontSize: "13px",
                color: "#718096",
              }}
            >
              {selectedDepartment !== "All" && (
                <div>
                  <strong>Department:</strong>{" "}
                  <span
                    style={{
                      padding: "2px 8px",
                      borderRadius: "12px",
                      fontSize: "12px",
                      background: departmentStyle.bg,
                      color: departmentStyle.color,
                    }}
                  >
                    {task.department}
                  </span>
                </div>
              )}
              <div>
                <strong>Assignee:</strong> {task.assignee}
              </div>
              <div>
                <strong>Due:</strong>{" "}
                {new Date(task.dueDate).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })}
              </div>
              <div>
                <strong>Status:</strong>{" "}
                <span style={{ textTransform: "capitalize" }}>
                  {task.status.replace("-", " ")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        padding: "40px",
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "30px",
        }}
      >
        <div>
          <h1
            style={{
              fontSize: "32px",
              fontWeight: "700",
              color: "#2d3748",
              marginBottom: "8px",
            }}
          >
            Tasks
          </h1>
          <p style={{ color: "#718096", fontSize: "16px" }}>
            Track and manage council tasks and assignments
          </p>
        </div>
        <button
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            border: "none",
            padding: "12px 24px",
            borderRadius: "8px",
            fontSize: "15px",
            fontWeight: "500",
            cursor: "pointer",
            boxShadow: "0 4px 6px rgba(102, 126, 234, 0.3)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow =
              "0 6px 12px rgba(102, 126, 234, 0.4)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow =
              "0 4px 6px rgba(102, 126, 234, 0.3)";
          }}
        >
          <FaPlus />
          New Task
        </button>
      </div>

      {/* Department Filters */}
      <div
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          marginBottom: "30px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "16px",
          }}
        >
          <FaFilter style={{ color: "#667eea" }} />
          <h3
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#2d3748",
              margin: 0,
            }}
          >
            Filter by Department
          </h3>
        </div>
        <div
          style={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          {departments.map((dept) => (
            <button
              key={dept}
              onClick={() => setSelectedDepartment(dept)}
              style={{
                padding: "8px 16px",
                borderRadius: "20px",
                border: "1px solid",
                borderColor:
                  selectedDepartment === dept ? "#667eea" : "#e2e8f0",
                background:
                  selectedDepartment === dept
                    ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                    : "white",
                color: selectedDepartment === dept ? "white" : "#4a5568",
                fontSize: "14px",
                fontWeight: selectedDepartment === dept ? "600" : "500",
                cursor: "pointer",
                transition: "all 0.2s",
              }}
              onMouseEnter={(e) => {
                if (selectedDepartment !== dept) {
                  e.currentTarget.style.borderColor = "#667eea";
                  e.currentTarget.style.background = "#f7fafc";
                }
              }}
              onMouseLeave={(e) => {
                if (selectedDepartment !== dept) {
                  e.currentTarget.style.borderColor = "#e2e8f0";
                  e.currentTarget.style.background = "white";
                }
              }}
            >
              {dept}
              {dept !== "All" && (
                <span
                  style={{
                    marginLeft: "6px",
                    fontSize: "12px",
                    opacity: 0.8,
                  }}
                >
                  ({tasks.filter((t) => t.department === dept).length})
                </span>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Stats */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "20px",
          marginBottom: "40px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: "20px",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
          }}
        >
          <div style={{ fontSize: "28px", fontWeight: "700", color: "#667eea" }}>
            {filteredTasks.length}
          </div>
          <div style={{ color: "#718096", fontSize: "14px", marginTop: "4px" }}>
            Total Tasks
            {selectedDepartment !== "All" && (
              <span style={{ display: "block", fontSize: "12px", marginTop: "2px" }}>
                in {selectedDepartment}
              </span>
            )}
          </div>
        </div>
        <div
          style={{
            background: "white",
            padding: "20px",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
          }}
        >
          <div style={{ fontSize: "28px", fontWeight: "700", color: "#d97706" }}>
            {activeTasks.length}
          </div>
          <div style={{ color: "#718096", fontSize: "14px", marginTop: "4px" }}>
            Active Tasks
          </div>
        </div>
        <div
          style={{
            background: "white",
            padding: "20px",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
          }}
        >
          <div style={{ fontSize: "28px", fontWeight: "700", color: "#38a169" }}>
            {completedTasks.length}
          </div>
          <div style={{ color: "#718096", fontSize: "14px", marginTop: "4px" }}>
            Completed
          </div>
        </div>
      </div>

      {/* Active Tasks */}
      <div style={{ marginBottom: "40px" }}>
        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            color: "#2d3748",
            marginBottom: "20px",
          }}
        >
          Active Tasks
          {selectedDepartment !== "All" && (
            <span style={{ fontSize: "18px", fontWeight: "500", color: "#718096", marginLeft: "12px" }}>
              — {selectedDepartment}
            </span>
          )}
        </h2>
        {activeTasks.length > 0 ? (
          activeTasks.map((task) => <TaskCard key={task.id} task={task} />)
        ) : (
          <p style={{ color: "#718096", fontStyle: "italic" }}>
            {selectedDepartment === "All" 
              ? "No active tasks" 
              : `No active tasks in ${selectedDepartment}`}
          </p>
        )}
      </div>

      {/* Completed Tasks */}
      <div>
        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            color: "#2d3748",
            marginBottom: "20px",
          }}
        >
          Completed Tasks
          {selectedDepartment !== "All" && (
            <span style={{ fontSize: "18px", fontWeight: "500", color: "#718096", marginLeft: "12px" }}>
              — {selectedDepartment}
            </span>
          )}
        </h2>
        {completedTasks.length > 0 ? (
          completedTasks.map((task) => <TaskCard key={task.id} task={task} />)
        ) : (
          <p style={{ color: "#718096", fontStyle: "italic" }}>
            {selectedDepartment === "All" 
              ? "No completed tasks" 
              : `No completed tasks in ${selectedDepartment}`}
          </p>
        )}
      </div>
    </div>
  );
}

